Teasers = {

    init: function(){

        if(typeof Editor != "undefined") return;

        var cells = $('.row[data-component="teaser-big"] > .content > .box > .cell').not('.no-link');

        cells.each(function(index, el) {
            
            var link = $(this).find('.button').attr('href');
            var target = $(this).find('.button').attr('target');

            if(!link) return;

            var func = target == "_blank" ? "open" : "location";

            if (target == "_blank")
                $(this).attr('onclick', 'window.open("' + link + '")');
            else
                $(this).attr('onclick', 'window.location="' + link + '"');

            $(this).css({cursor: 'pointer'});
            
        });
    }
}